/*
 * La versión que corre en ESTE navegador. Sirve para dos cosas:
 *  - Soporte: «¿qué versión dice abajo?» dice al instante si ese equipo tiene lo
 *    último o una copia vieja en caché (pasa en los kioscos, que no se cierran).
 *  - Aviso: el personal ve que el número cambió y sabe que hubo una entrega.
 */
export const VERSION = typeof __APP_VERSION__ !== "undefined" ? __APP_VERSION__ : "dev";
export const COMMIT = typeof __APP_COMMIT__ !== "undefined" ? __APP_COMMIT__ : "local";
export const FECHA_BUILD = typeof __APP_FECHA__ !== "undefined" ? __APP_FECHA__ : "";

/** "29 sep 2026", en hora de Puerto Rico. */
export function fechaLegible(iso: string = FECHA_BUILD): string {
  if (!iso) return "";
  return new Date(iso).toLocaleDateString("es-PR", {
    day: "numeric", month: "short", year: "numeric", timeZone: "America/Puerto_Rico",
  });
}
